import React, { useEffect, useState } from 'react'
import { AcountingHeading } from '../common/AcountingHeading'
import { Item } from '../../../common/snippets'
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import FranchiseePendingTopayRptTable from './FranchiseePendingTopayRptTable'
import { columnDefs, columnDefsForExcel, headerColDefs, statusList, tblData } from './constants'
import Lineinput from '../../../common/lineinput'
import * as url from '../../Reports/oldReportsUrls'
import { appendToUrl, calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, clickElement, focusElemnt, generateDynamicColumnStyles, isEmpty, navigation1, navigation3 } from '../../../common/helper'
import { getBranchList, getCityList, getFtlBkngBranchList, updateAlertError } from '../../../../store/common/common_action'
import { FranchiseePendingToPayUpdateData, getFranchiseePendingTopayRptData } from '../../../../store/reports/reports_action'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { API_CACHE_DURATION } from '../../../common/constants'
const FranchiseePendingTopayReport = (props) => {
  const {
    data: { common, reports }, getCityList, getFtlBkngBranchList, getFranchiseePendingTopayRptData, FranchiseePendingToPayUpdateData, updateAlertError

  } = props
  //   const { ownChildBranches1, reportBranchList, creditTransactionReportData } = reports
  const { loginData, cityList, companySettings } = common
  const allownFormatLR = companySettings?.[0]?.UseFormattedLRinReports
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), srcCity: '', srcBranch: '', destCity: '', destBranch: '', status: statusList[0] })
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState([])
  const [brnchList, setBranchList] = useState([])
  const [srcCityList, setSrcCityList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [srcBranchList, setSrcBranchList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])
  const [selectAllLR, setSelectAllLR] = useState(false)
  const [selectedData, setSelectedData] = useState([])
  const [selectLr, setSelectLr] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [columns, setColumns] = useState([])
  const [excelColumns, setExcelColumns] = useState([])
  const [resetFilters, setResetFilters] = useState(false)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const reportName = 'Franchisee Pending ToPay'
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  const handleClick1 = () => {
    if (Math.abs(filters?.toDate.diff(filters?.fromDate, 'days'))>31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else if (filters?.srcCity === '') {
      updateAlertError({ show: true, msg: 'Please Select Source City', nextId: 'srcCity' })
      return
    } else if (filters?.srcBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select Source Branch', nextId: 'srcBranch' })
      return
    } else if (filters?.destCity === '') {
      updateAlertError({ show: true, msg: 'Please Select Destination City', nextId: 'destCity' })
      return
    } else if (filters?.destBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select Destination Branch', nextId: 'destBranch' })
      return
    } else  if(filters?.status===''){
      updateAlertError({ show: true, msg: 'Please Select Status', nextId: 'status' })
      return
    }
    else {
      let body = {
        CompanyID: loginData?.intCompanyID,
        BookingCityID: filters?.srcCity?.CityID,
        BookingBranchID: filters?.srcBranch?.BranchID,
        DestinationCityID: filters?.destCity?.CityID,
        DestinationBranchID: filters?.destBranch?.BranchID,
        dtFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(filters?.toDate).format('YYYY-MM-DD'),
        Status: filters?.status?.id,
        UserID: loginData?.intUserID
      }
      getFranchiseePendingTopayRptData(body).then((res) => {
        if (res.status === 'Success') {
          let newData = groupData(res?.Data?.Table)
          setTableData(newData)
          setSelectedData([])
          setShowTable(true)
        } else {
          setTableData([])
          setSelectedData([])
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      }).catch((err) => {
        console.log('Error:', err)
        updateAlertError({ show: true, msg: err, nextId: '' })
      })
    }
  }
  useEffect(()=>{
    focusElemnt('fromDate')
  },[])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getCityList(loginData, true, API_CACHE_DURATION)
      let BranchBody = {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intCityID: 0,
        intBookingBranchID: -1
      }
      getFtlBkngBranchList(BranchBody).then((res) => {
        if (res.status === 'Success') {
          setBranchList(res?.Data?.Table)
        } else {
          setBranchList([])
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }, [loginData])

  useEffect(() => {
    if (cityList?.length > 0) {
      let newData = [{ CityID: 0, CityName: 'All' }, ...cityList]
      setDestCityList(newData)
      setFilters((prev) => ({
        ...prev,
        srcCity: newData[0],
        destCity: newData[0],
      }))
    }
  }, [cityList])
  // useEffect(() => {
  //   if (filters?.srcCity) {
  //     let newList = []
  //     let branchData = []
  //     if (cityList?.length > 0) {
  //       if (filters?.srcCity?.CityID === 0) {
  //         newList = [{ CityID: 0, CityName: 'All' }, ...cityList]
  //         branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
  //         setSrcBranchList(branchData)
  //         setDestCityList(newList)
  //       } else {
  //         let filterCity = cityList?.filter((val) => val.CityID !== filters?.srcCity?.CityID)
  //         newList = [{ CityID: 0, CityName: 'All' }, ...filterCity]
  //         setDestCityList(newList)
  //         let srcBranchData = brnchList?.filter((val) => val?.CityID === filters?.srcCity?.CityID)
  //         branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]
  //         setSrcBranchList(branchData?.length > 1 ? branchData : [])
  //       }
  //     }
  //     setFilters((prev) => ({
  //       ...prev,
  //       srcBranch: branchData?.[0],
  //       destCity: newList?.[0],
  //     }))
  //   }
  // }, [filters?.srcCity, brnchList])
  useEffect(() => {
    if (filters?.destCity) {
      let newList = []
      let branchData = []
      if (cityList?.length > 0) {
        if (filters?.destCity?.CityID === 0) {
          newList = [{ CityID: 0, CityName: 'All' }, ...cityList]
          branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
          setDestBranchList(branchData)
          setSrcCityList(newList)
        } else {
          let filterCity = cityList?.filter((val) => val.CityID !== filters?.destCity?.CityID)
          newList = [{ CityID: 0, CityName: 'All' }, ...filterCity]
          setSrcCityList(newList)
          let destBranchData = brnchList?.filter((val) => val?.CityID === filters?.destCity?.CityID)
          branchData = [{ BranchID: 0, BranchName: 'All' }, ...destBranchData]
          setDestBranchList(branchData?.length > 1 ? branchData : [])
        }
      }
      setFilters((prev) => ({
        ...prev,
        destBranch: branchData?.[0],
        srcCity: newList?.[0],
      }))
    }
  }, [filters?.destCity, brnchList])
  // useEffect(() => {
  //   if (filters?.destCity) {
  //     let branchData = []
  //     if (filters?.destCity?.CityID === 0 && filters?.srcCity?.CityID === 0) {
  //       branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
  //     } else if (filters?.destCity?.CityID === 0 && filters?.srcCity?.CityID !== 0) {
  //       let destBranchData = brnchList?.filter((val) => val.CityID !== filters?.srcCity?.CityID)
  //       branchData = [{ BranchID: 0, BranchName: 'All' }, ...destBranchData]

  //     }
  //     else if (filters?.destCity?.CityID !== 0 && filters?.srcCity?.CityID === 0) {
  //       let destBranchData = brnchList?.filter((val) => val?.CityID === filters?.destCity?.CityID)
  //       branchData = [{ BranchID: 0, BranchName: 'All' }, ...destBranchData]
  //     } else {
  //       let destBranchData = brnchList?.filter((val) => val?.CityID === filters?.destCity?.CityID && val?.CityID !== filters?.srcCity?.CityID)
  //       branchData = [{ BranchID: 0, BranchName: 'All' }, ...destBranchData]
  //     }
  //     setDestBranchList(branchData?.length > 1 ? branchData : [])
  //     setFilters((prev) => ({
  //       ...prev,
  //       destBranch: branchData?.[0]
  //     }))
  //   }
  // }, [filters?.destCity, brnchList])
  useEffect(() => {
    if (filters?.srcCity) {
      let branchData = []
      if (filters?.srcCity?.CityID === 0 && filters?.destCity?.CityID === 0) {
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...brnchList]
      } else if (filters?.srcCity?.CityID === 0 && filters?.destCity?.CityID !== 0) {
        let srcBranchData = brnchList?.filter((val) => val.CityID !== filters?.destCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]

      }
      else if (filters?.srcCity?.CityID !== 0 && filters?.destCity?.CityID === 0) {
        let srcBranchData = brnchList?.filter((val) => val?.CityID === filters?.srcCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]
      } else {
        let srcBranchData = brnchList?.filter((val) => val?.CityID === filters?.srcCity?.CityID && val?.CityID !== filters?.destCity?.CityID)
        branchData = [{ BranchID: 0, BranchName: 'All' }, ...srcBranchData]
      }
      setSrcBranchList(branchData?.length > 1 ? branchData : [])
      setFilters((prev) => ({
        ...prev,
        srcBranch: branchData?.[0]
      }))
    }
  }, [filters?.srcCity, brnchList])
  
  useEffect(()=>{
    if(allownFormatLR===1||allownFormatLR===0){
      setColumns(columnDefs)
      setExcelColumns(columnDefsForExcel)
    }else if(allownFormatLR===2){
      let newCols = [...columnDefs]
      let newExcelCols = [...columnDefsForExcel]
      newCols[1].header='Formatted LR'
      newCols[1].dataKey='FormattedLRNO'
      setColumns(newCols)
      newExcelCols[1].header = 'Formatted LR'
      newExcelCols[1].dataKey = 'FormattedLRNO'
      setExcelColumns(newExcelCols)
    }else if(allownFormatLR===3){
      let newCols = [...columnDefs]
      newCols[1].headerSx.width='10%'
      newCols[3].headerSx.width='8%'
      const newObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '9%', textAlign: 'left' } }
      newCols.splice(2, 0, newObject);
      setColumns(newCols);
      let newExcelCols = [...columnDefsForExcel]
      const newExcelObject =  { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 131.11} }
      newExcelCols.splice(2, 0, newExcelObject);
      setExcelColumns(newExcelCols);
    }
  },[allownFormatLR, columnDefs])

  const handleClick2 = () => {
    let url = url.franchiseePendingToPayReport
    const urlData = url.franchiseePendingToPayReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDate = moment(filters?.fromDate).format('DD-MMM-YYYY')
    urlData.ToDate = moment(filters?.toDate).format('DD-MMM-YYYY')
    urlData.BookingCityId = filters?.srcCity?.CityID
    urlData.BookingBranchId = filters?.srcBranch?.BranchID
    urlData.DestinationCityId = filters?.destCity?.CityID
    urlData.DestinationBranchId = filters?.destBranch?.BranchID
    urlData.intStatus = filters?.status?.id
    urlData.UserId = loginData?.intUserID
    urlData.BookingCityName = filters?.srcCity?.CityName
    urlData.BookingBranchName = filters?.srcBranch?.BranchName
    urlData.DestinationCityName = filters?.destCity?.CityName
    urlData.DestinationBranchName = filters?.destBranch?.BranchName
    urlData.strStatus = filters?.status?.name
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const groupData = (data) => {
    const groupedData = {};

    data.forEach(item => {
      const key = `${item.ToCityID}-${item.ToBranchID}`;

      if (!groupedData[key]) {
        groupedData[key] = {
          isSubHeading: true,
          GeneratedDateTime: `Destination: ${item.ToCity} - ${item.ToBranch}`,
          toPayData: []
        };
      }

      groupedData[key].toPayData.push({
        isDataRow: true,
        VoucherNo: item.VoucherNo,
        GeneratedDateTime: item.GeneratedDateTime,
        LRNO: item.LRNO,
        FormattedLRNO:item.FormattedLRNO,
        ChallanNo: item.ChallanNo,
        FromCity: item.FromCity,
        FromBranch: item.FromBranch,
        TotalItems: item.TotalItems,
        TopayAmt: item.TopayAmt,
        IsReceived: Number(item.IsReceived),
        isRecValue: Number(item.IsReceived),
        Remarks: item.Remarks,
        remarkValue:item.Remarks
      });
    });

    // Convert the grouped object back to an array
    return Object.values(groupedData).map(group => {
      const totalQty = group.toPayData.reduce((sum, row) => sum + row.TotalItems, 0);
      const totalAmount = group.toPayData.reduce((sum, row) => sum + row.TopayAmt, 0);

      group.toPayData.push({
        isTotalRow: true,
        GeneratedDateTime: 'Total',
        TotalItems: totalQty,
        TopayAmt: totalAmount
      });

      return group;
    });
  }
  const handleSelectAllLR = (e) => {
    let newData = [...tableData];
    const isChecked = e.target.checked;

    newData.forEach((item) => {
      item.toPayData.forEach((row) => {
        row.isRecValue = isChecked ? 1 : 0;
      });
    });
    setTableData(newData);
    setSelectAllLR(isChecked);
    if (isChecked) {
      // If checked, add all rows to selectedData
      const allRows = newData.flatMap(item => item.toPayData); // Flatten the toPayData arrays
      const newSelectedData = allRows.filter(row => !row.isTotalRow); // Assuming each row has a unique 'BookingID'
      setSelectedData(newSelectedData); // Set selectedData to all rows
    } else {
      // If unchecked, clear selectedData
      setSelectedData([]); // Clear selectedData
    }
  }
  const handleUpdate = () => {
    if (selectedData?.length <= 0) {
      updateAlertError({ show: true, msg: 'Please Select Atleast One Row For Updating', nextId: '' })
      return
    } else {
      let body = {
        VoucherNos: selectedData.map(row => row.VoucherNo).join('^'),
        Remarks: selectedData.map(row => row.remarkValue).join('^'),
        UserID: loginData?.intUserID
      }
      FranchiseePendingToPayUpdateData(body).then((res) => {
        if (res.status === 'Success') {
          setIsSuccess(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          return
        }
      }).catch((err) => {
        console.log('Error:', err)
      })
    }
  }
  const generatepdf = (isSave) => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const bodyData = tableData?.flatMap((item) => {
      if (item.isSubHeading) {
        // Modify the toPayData items and return the subheading item along with the modified toPayData
        const modifiedToPayData = item.toPayData.map((data) => ({
          ...data,
          IsReceived: data.IsReceived === 1 ? 'Yes' : data.IsReceived === 0 ? 'No' : '' // Change IsReceived property
        }));

        return [item, ...modifiedToPayData]; // Return the item and the modified toPayData
      }
    });

    const HeaderData = [
      {
        srcCity: filters?.srcCity?.CityName,
        srcBranch: filters?.srcBranch?.BranchName,
        destCity: filters?.destCity?.CityName,
        destBranch: filters?.destBranch?.BranchName,
        status: filters?.status?.name,
      },
    ]
    const pdfHeaderCol = headerColDefs?.filter((item) => item?.dataKey !== 'fromDate' && item?.dataKey !== 'toDate')
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
        (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
      )
    }
    doc.setProperties({
      title: `Franchisee Pending ToPay Report.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Franchisee Pending ToPay Report',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfHeaderCol,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      styles: {
        fontStyle: 'bold',
        fontSize: 15,
      },
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 15,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      startY: doc.lastAutoTable.finalY + 24,
      columns: excelColumns,
      body: bodyData,
      columnStyles:allownFormatLR===3? {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 150, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 150, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 90, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 90, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 120, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        9: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      }:
      {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 162.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 162.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 131.11, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      // generateDynamicColumnStyles(excelColumns, 14),
      // showHead: 'repeat',
      theme: 'grid',
      styles: {
        fontSize: 15,
        lineWidth: [0, 0.6, 0, 0.6],
        fontStyle: 'bold',
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 15,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'bold',
        font: 'Roboto',
      },
      didParseCell: (data) => {
        if (data.row.section === 'head' || data.row.section === 'body') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        if (data.row.raw.isSubHeading) {
          data.row.cells[0].colSpan =excelColumns?.length ;
        }
      },
      
      willDrawCell: (data) => {
        if (data.row.raw.isSubHeading) {
          doc.setFillColor(218, 237, 254);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(15).setFont("Roboto", 'bold')
          data.cell.styles.valign = 'middle';
        } else if (data.row.raw.isTotalRow) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(15).setFont("Roboto", 'bold')
          data.cell.styles.valign = 'middle';
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Booking Date : ${moment(filters?.fromDate).format('DD-MMM-YYYY')} To ${moment(filters?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report:Franchisee Pending ToPay Report`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Accounting Reports', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(20).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // Open the PDF in a new tab
    window.open(pdfUrl);
  }
  const handleReset = () => {
    setFilters({ fromDate: moment(new Date()), toDate: moment(new Date()), srcCity: '', srcBranch: '', destCity: '', destBranch: '', status: statusList[0] })
    setShowTable(false)
    setTableData([])
    setSelectAllLR(false)
    setSelectedData([])
    setSelectLr('')
    setResetFilters(true)
    setTimeout(() => {
    setResetFilters(false)
    }, 0);
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
      </Item>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }}>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id='company'
            label={'Select Company'}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            id='fromDate'
            value={filters?.fromDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              setShowTable(false)
              focusElemnt('toDate')
            }}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            id='toDate'
            value={filters?.toDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              setShowTable(false)
              focusElemnt('destCity')
            }}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'destCity'}
            label={'Destination City'}
            data={destCityList || []}
            defaultvalue={filters?.destCity?.CityName}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                destCity: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Destination City`}
            width="100%"
            nextId={'destBranch'}
            prevId={'toDate'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17.5%' }}>
          <DropDownOA
            id={'destBranch'}
            label={'Detination Branch'}
            data={destBranchList || []}
            defaultvalue={filters?.destBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                destBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Detination Branch`}
            width="100%"
            nextId={'srcCity'}
            prevId={'destCity'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'srcCity'}
            label={'Source City'}
            data={srcCityList || []}
            defaultvalue={filters?.srcCity?.CityName}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                srcCity: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Source City`}
            width="100%"
            nextId={'srcBranch'}
            prevId={'destBranch'}
          />
        </Item>
      </Box>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }}>
      <Item sx={{ ...sx.itemsx, width: '17%' }}>
          <DropDownOA
            id={'srcBranch'}
            label={'Source Branch'}
            data={srcBranchList || []}
            defaultvalue={filters?.srcBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                srcBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Source Branch`}
            width="100%"
            nextId={'status'}
            prevId={'srcCity'}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17.6%' }}>
          <DropDownOA
            id={'status'}
            label={'Status'}
            data={statusList || []}
            defaultvalue={filters?.status?.name}
            idKey={`id`}
            dataKey={`name`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                status: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Status`}
            width="100%"
            nextId={'splitButton'}
            prevId={'destBranch'}
          />
        </Item>
        <Item
          sx={sx.itemsx}
        onKeyDown={(e) => navigation3(e, 'refreshBtn','status', () => handleClick1())}
        >
          <SplitButton
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            id1={'splitButton'}
            //   prevID={disableBtn ? id.toDate : id.srcBranch}
            onClick1={handleClick1}
            onClick2={handleClick2}
          />
        </Item>
        <Item
          sx={{ ...sx.itemsx, padding:'5px 5px' }}
          id='refreshBtn'
          tabIndex={0}
          onKeyDown={(e) => navigation3(e, showTable?'excelBtn':'fromDate','splitButton', () => handleReset())}
          onClick={() => {
            handleReset()
          }}
        >
          <RefreshSvg />
        </Item>
      </Box>
      <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', padding: '0px' }}>
        {showTable && <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '22px' }}>Report For: Franchisee Pending ToPay Report</h3>
        </Box>}
        <Box
          className='reportButton'
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '22px',
            gap: '16px'
          }}
        >
          {showTable && (
            <>
              <Item sx={{ ...sx.itemsx }} className="">
                <Button
                  variant="outlined"
                  color="secondary"
                  id={'excelBtn'}
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={(e) => {
                    e.preventDefault()
                    clickElement('xls-button-memo')
                  }}
                  onKeyDown={(e) => navigation1(e, 'print', 'refreshBtn')}
                >
                  Export To Excel
                </Button>
                <ReactHtmlTableToExcel
                  id="xls-button-memo"
                  table="delivery-memo-excel-tbl"
                  filename={'Franchisee Pending ToPay Report'}
                  sheet="sheet 1"
                  buttonText="EXPORT AS EXCEL"
                  className="excel-button"
                />
              </Item>
              <Item sx={{ ...sx.itemsx }} className="">
                <Button id={"print"} variant="outlined" className="receiveitembtn"
                  onClick={() => { generatepdf() }}
                onKeyDown={(e) => {
                  navigation1(e, showTable?'QRPaymentActive':'', 'excelBtn')
                }}
                >
                  Export To PDF
                </Button>
              </Item>
            </>)}
        </Box>
      </Box>
      {showTable && <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', paddingTop: '5px' }}>
        <FranchiseePendingTopayRptTable tableData={tableData} setTableData={setTableData} selectedData={selectedData} setSelectedData={setSelectedData}
          selectLr={selectLr} setSelectLr={setSelectLr} filters={filters} loginData={loginData} columns={columns} excelColumns={excelColumns} allownFormatLR={allownFormatLR}/>
      </Box>}
     {showTable && <Box className='reportButton' sx={{
        display: 'flex',
        flexDirection: 'row',
        position: 'fixed',
        justifyContent: 'flex-start',
        alignItems: 'center',
        bottom: 0,
        left: 0,
        right: 0,
        height: '70px',
        gap: '15px',
        border: '1px solid rgba(166, 168, 171, 0.5)',
        backgroundColor: '#F5FAFE', // Optional: to ensure it has a background
        padding: '12px 15px 12px 15px'
      }}>
        <Typography>Grand Total: </Typography>
        <Item className={'input--wrapper btmSpaceNotRequired'} style={{ width: '10%', }} >
          <Lineinput
            id=''
            value={selectedData?.reduce((acc, row) => acc + (row.TopayAmt || 0), 0) || 0}
            disabled
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '14%' }}>
          <FormControlLabel
            control={
              <Checkbox
                id={`QRPaymentActive`}
                checked={selectAllLR}
                onChange={(e) => {
                  handleSelectAllLR(e)
                }}
                disabled={tableData?.length===0}
                onKeyDown={(e) => {
                  navigation1(e, 'update_btn','print')
                }}
              />
            }
            label={'Select All Unpaid LRs'}
          />
        </Item>
        <Button
          variant="contained"
          onKeyDown={(e) => navigation3(e, 'fromDate', 'QRPaymentActive', () => { })}
          id={'update_btn'}
          sx={{ width: '100px', padding: '6px !important', fontSize: '14px !important' }}
          className="btn btn-primary"
          disabled={tableData?.length===0}
          onClick={() => {
            handleUpdate()
          }
          }
        > Update
        </Button>
        {/* <Button id={"CANCEL"} variant="outlined" className="receiveitembtn"
          onClick={() => { }}
          // onKeyDown={(e) => {
          //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
          // }}
          style={{ width: '100px' }}
        >
          Close
        </Button> */}

      </Box>}
      <SuccessAndErrorModal
        handleClose={() => {
          setIsSuccess(false);
        }} open={isSuccess} title={`Updated Successfully`} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getCityList, getFtlBkngBranchList, getFranchiseePendingTopayRptData, FranchiseePendingToPayUpdateData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseePendingTopayReport)

